<template>
  <div style="overflow: none; height: 100vh;">
    <v-toolbar
      flat
      style="position: -webkit-sticky; /* Safari */position: sticky; z-index: 3"
    >
      <v-toolbar-title> <v-icon>layers </v-icon> Kartlag </v-toolbar-title>
      <v-subheader v-if="currentlyOpenedProject">{{
        currentlyOpenedProject.attributes.tittel
      }}</v-subheader>

      <v-spacer></v-spacer>

      <v-btn label="Skjul kartlag" aria-label="Skjul kartlag" icon @click="hideDrawer">
        <v-icon>chevron_left</v-icon>
      </v-btn>
    </v-toolbar>

    <layer-list-toolbar />

    <v-divider style="margin: 0px;"></v-divider>

    <div
      class="elevation-2"
      style="margin-top: 0px; overflow-y: scroll; height: calc(100% - 113px); overflow-x: hidden"
    >
      <draggable
        v-model="mapProfiles"
        :disabled="$vuetify.breakpoint.smAndDown"
        @change="onLayerDragged"
      >
        <div v-for="(item, index) in mapProfiles" :key="item.id">
          <layer-list-item
            @remove="removeLayer(item)"
            @place-on-top="placeOnTop(item)"
            @place-on-bottom="placeOnBottom(item)"
            :item="item"
            :is-on-top="index == 0"
            :is-on-bottom="index == mapProfiles.length - 1"
          ></layer-list-item>
        </div>
      </draggable>

      <div
        style="height: 100%; margin-top: -50px;"
        v-if="
          layersAreLoading ||
            mapProfiles.length == 0 ||
            (mapProfiles.length == 1 && mapProfiles[0].id === 'bygninger3d')
        "
      >
        <v-layout align-center justify-center row fill-height>
          <div v-if="!layersAreLoading">
            <h3>Kartlagslisten er tom..</h3>
            <v-btn @click="openExplorer" label="Legg til innhold" aria-label="Legg til innhold" flat color="blue">
              Legg til innhold
            </v-btn>
          </div>
          <v-layout v-else align-center justify-center column>
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
            <h4 class="pt-0 mt-1">Laster kartlag</h4>
          </v-layout>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
import LayerListToolbar from "@/pages/MapPage/Tools/Layers/LayerListToolbar";
import LayerListItem from "@/pages/MapPage/Tools/Layers/LayerListItem";
import draggable from "vuedraggable";
import MappingMixin from "@/mixins/mappingMixin";
import { mapState, mapActions } from "vuex";
export default {
  name: "LayerList",
  data() {
    return {
      menu: false,
      selectedCategories: [],
      openProjectDialogActive: false,
      saveProjectDialogActive: false,
      projectSaveInProgress: false,
      confirmNewEmptyProjectDialog: false,
      saveProjectSettings: false,
      operationalItems: null
    };
  },
  mixins: [MappingMixin],
  components: {
    draggable,
    LayerListItem,
    LayerListToolbar
  },
  computed: {
    ...mapState(["currentlyOpenedProject", "layersAreLoading"]),
    mapProfiles: {
      get() {
        return this.$store.state.mapProfiles.slice().reverse();
      },
      set(value) {
        this.updateMapProfiles(value.slice().reverse());
      }
    }
  },
  methods: {
    ...mapActions([
      "updateMapProfiles",
      "setSelectedTheme",
      "setShowSideMenu",
      "setExplorerVisible"
    ]),
    addTheme(themeId) {
      for (let i = 0; i < this.categories.length; i++) {
        let category = this.categories[i];
        for (let j = 0; j < category.items.length; j++) {
          if (category.items[j].id === themeId) {
            this.selectedCategories.push(category.items[j]);
            this.toggleTheme(null, category.items[j], true);
          }
        }
      }
    },
    toggleTheme(evt, item, firstTime) {
      if (evt) evt.stopPropagation();
      firstTime ? (item.visible = true) : (item.visible = !item.visible);
      this.setSelectedTheme(item.id);
      this.$eventHub.$emit("toggle-theme", item.id);
    },
    removeLayer(item) {
      this.removeMapProfile(item.id);
    },
    hideDrawer() {
      this.setShowSideMenu(false);
    },
    openExplorer() {
      this.setExplorerVisible(true);
    },
    onLayerDragged(evt) {
      let correctIndex = this.mapProfiles
        .slice()
        .reverse()
        .map(e => e.id)
        .indexOf(evt.moved.element.id);
      this.reorder(evt.moved.element.id, correctIndex);
      let photolayer = this.$theMapObject.findLayerById("foto");
      if (photolayer) {
        this.$theMapObject.reorder(photolayer, 1000);
      }
    },
    reorder(id, newIndex) {
      let exisitingLayer = this.$theMapObject.findLayerById(id);

      this.$theMapObject.reorder(exisitingLayer, newIndex);
      exisitingLayer.refresh();
    },
    placeOnTop(item) {
      let mapProfilesCopy = JSON.parse(JSON.stringify(this.mapProfiles));
      let index = this.mapProfiles.findIndex(profile => profile.id === item.id);
      let profileBeingMoved = mapProfilesCopy.splice(index, 1)[0];
      mapProfilesCopy.push(profileBeingMoved);
      this.mapProfiles = mapProfilesCopy;
      this.reorder(item.id, this.mapProfiles.length + 1);
    },
    placeOnBottom(item) {
      let mapProfilesCopy = JSON.parse(JSON.stringify(this.mapProfiles));
      let index = this.mapProfiles.findIndex(profile => profile.id === item.id);
      let profileBeingMoved = mapProfilesCopy.splice(index, 1)[0];
      mapProfilesCopy.unshift(profileBeingMoved);
      this.mapProfiles = mapProfilesCopy;
      this.reorder(item.id, 0);
    },
    setOpacity(layerId, opacity) {
      let exisitingLayer = this.$theMapObject.findLayerById(layerId);

      exisitingLayer.opacity = opacity / 100;
    }
  },
  created() {
    this.$eventHub.$on("add-theme", this.addTheme);
  },
  beforeDestroy() {
    this.$eventHub.$off("add-theme");
  }
};
</script>

<style></style>
